import { ButtonVariant, Direction, TextAlign } from 'scripts/type'
import { WidgetWidth } from 'components/business/Preview/type'

export const HOWXM_NAMESPACE = '_howxm_xform'
export const FIELD_PAGE_SCROLL_WRAPPER_SELECTOR = 'field-scroll-wrapper'
export const SURVEY_ACTION_AREA_SELECTOR = 'actions-area'
export const SURVEY_FIELD_PAGE_SELECTOR = 'field-page'
export const FIELD_ENTER_ANIMATION_PREFIX = 'field-enter'

export * from './gql'

export const SCREEN_BREAK_POINT = 640

export const SDK_MODAL_TRANSITION_DURATION = 300 // same with sdk iframe transition-duration(.widgetTransition)

export const PAGE_SUBMIT_DELAY = 500
// auto close time is 2seconds, but need field change animation finished, the time is .8seconds, so auto close time is 2.8seconds
export const WIDGET_AUTO_CLOSE_DURATION = 2800
export const MAX_FIELD_LABEL_LENGTH_IN_ENGLISH = 6 * 2 // 6个中文，12个英文

export const WIDGET_WIDTH = {
  [WidgetWidth.SMALL]: 320,
  [WidgetWidth.NORMAL]: 400,
  [WidgetWidth.LARGE]: 500,
  [WidgetWidth.XLARGE]: 540,
}
export const MOB_SIMULATOR_WIDGET_WIDTH = 352
export const URL_VISIT_MAX_WIDTH = 540

export const defaultColorScheme = {
  accent: '#3b82f6',
  background: '#ffffff',
}

export const defaultButtonStyle = {
  variant: ButtonVariant.FILLED,
  borderRadius: 18,
}

export const defaultTextStyle = {
  align: TextAlign.START,
  direction: Direction.LTR,
}

export const ERROR_CAMPAIGN_CLOSED = 'error.campaign_closed'
export const ERROR_SUBSCRIPTION_BALANCE_INSUFFICIENT = 'error.subscription_balance_insufficient'
